var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1727,
    height: 943,
    viewBox: "0 0 1727 943",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11,
    clipPath: "url(#clip0_2021_3321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1727 0H-1V943H1727V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5455 70.7255L69.6909 62.8672L61.8364 70.7255L69.6909 78.5839L61.8364 86.4422L69.6909 94.3005L77.5455 86.4422L85.4 94.3005L93.2545 86.4422L85.4 78.5839L93.2545 70.7255L85.4 62.8672L77.5455 70.7255Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.345 62.8672H218.927V66.0105H250.345V62.8672Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.345 69.1523H218.927V72.2957H250.345V69.1523Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.345 75.4414H218.927V78.5847H250.345V75.4414Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.345 81.7266H218.927V84.8699H250.345V81.7266Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.345 88.0156H218.927V91.159H250.345V88.0156Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.436 62.8672H376.018V94.3005H407.436V62.8672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.595 78.593C403.936 78.593 407.455 75.0726 407.455 70.7301C407.455 66.3875 403.936 62.8672 399.595 62.8672C395.255 62.8672 391.736 66.3875 391.736 70.7301C391.736 75.0726 395.255 78.593 399.595 78.593ZM399.595 76.2341C402.634 76.2341 405.097 73.7699 405.097 70.7301C405.097 67.6903 402.634 65.2261 399.595 65.2261C396.557 65.2261 394.094 67.6903 394.094 70.7301C394.094 73.7699 396.557 76.2341 399.595 76.2341Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.595 82.5252L395.666 78.5938L391.736 82.5252L395.666 86.4566L391.736 90.3881L395.666 94.3195L399.595 90.3881L403.525 94.3195L407.455 90.3881L403.525 86.4566L407.455 82.5252L403.525 78.5938L399.595 82.5252Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.527 62.8672H533.109V94.3005H564.527V62.8672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.968 94.3195C545.309 94.3195 548.827 90.7992 548.827 86.4566C548.827 82.1141 545.309 78.5938 540.968 78.5938C536.628 78.5938 533.109 82.1141 533.109 86.4566C533.109 90.7992 536.628 94.3195 540.968 94.3195ZM540.968 91.9607C544.006 91.9607 546.47 89.4964 546.47 86.4566C546.47 83.4169 544.006 80.9526 540.968 80.9526C537.93 80.9526 535.467 83.4169 535.467 86.4566C535.467 89.4964 537.93 91.9607 540.968 91.9607Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.686 94.3195C561.027 94.3195 564.545 90.7992 564.545 86.4566C564.545 82.1141 561.027 78.5938 556.686 78.5938C552.346 78.5938 548.827 82.1141 548.827 86.4566C548.827 90.7992 552.346 94.3195 556.686 94.3195ZM556.686 91.9607C559.725 91.9607 562.188 89.4964 562.188 86.4566C562.188 83.4169 559.725 80.9526 556.686 80.9526C553.648 80.9526 551.185 83.4169 551.185 86.4566C551.185 89.4964 553.648 91.9607 556.686 91.9607Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.909 94.3005C714.585 94.3005 721.618 87.2639 721.618 78.5839C721.618 69.9038 714.585 62.8672 705.909 62.8672C697.233 62.8672 690.2 69.9038 690.2 78.5839C690.2 87.2639 697.233 94.3005 705.909 94.3005ZM705.909 89.5855C711.982 89.5855 716.905 84.6599 716.905 78.5839C716.905 72.5078 711.982 67.5822 705.909 67.5822C699.836 67.5822 694.913 72.5078 694.913 78.5839C694.913 84.6599 699.836 89.5855 705.909 89.5855Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863 94.3005C871.676 94.3005 878.709 87.2639 878.709 78.5839C878.709 69.9038 871.676 62.8672 863 62.8672C854.324 62.8672 847.291 69.9038 847.291 78.5839C847.291 87.2639 854.324 94.3005 863 94.3005ZM863 89.5855C869.073 89.5855 873.996 84.6599 873.996 78.5839C873.996 72.5078 869.073 67.5822 863 67.5822C856.927 67.5822 852.004 72.5078 852.004 78.5839C852.004 84.6599 856.927 89.5855 863 89.5855Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.09 94.3005C1028.77 94.3005 1035.8 87.2639 1035.8 78.5839C1035.8 69.9038 1028.77 62.8672 1020.09 62.8672C1011.42 62.8672 1004.38 69.9038 1004.38 78.5839C1004.38 87.2639 1011.42 94.3005 1020.09 94.3005ZM1020.09 89.5855C1026.16 89.5855 1031.09 84.6599 1031.09 78.5839C1031.09 72.5078 1026.16 67.5822 1020.09 67.5822C1014.02 67.5822 1009.09 72.5078 1009.09 78.5839C1009.09 84.6599 1014.02 89.5855 1020.09 89.5855Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1334.27 94.3005C1342.95 94.3005 1349.98 87.2639 1349.98 78.5839C1349.98 69.9038 1342.95 62.8672 1334.27 62.8672C1325.6 62.8672 1318.56 69.9038 1318.56 78.5839C1318.56 87.2639 1325.6 94.3005 1334.27 94.3005ZM1334.27 89.5855C1340.35 89.5855 1345.27 84.6599 1345.27 78.5839C1345.27 72.5078 1340.35 67.5822 1334.27 67.5822C1328.2 67.5822 1323.28 72.5078 1323.28 78.5839C1323.28 84.6599 1328.2 89.5855 1334.27 89.5855Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.07 62.8672H1475.65V66.0105H1507.07V62.8672Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.07 69.1523H1475.65V72.2957H1507.07V69.1523Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.07 75.4414H1475.65V78.5847H1507.07V75.4414Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.07 81.7266H1475.65V84.8699H1507.07V81.7266Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.07 88.0156H1475.65V91.159H1507.07V88.0156Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2545 220.035H61.8364V251.468H93.2545V220.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6955 235.761C74.0359 235.761 77.5546 232.241 77.5546 227.898C77.5546 223.555 74.0359 220.035 69.6955 220.035C65.355 220.035 61.8364 223.555 61.8364 227.898C61.8364 232.241 65.355 235.761 69.6955 235.761ZM69.6955 233.402C72.7338 233.402 75.1968 230.938 75.1968 227.898C75.1968 224.858 72.7338 222.394 69.6955 222.394C66.6571 222.394 64.1941 224.858 64.1941 227.898C64.1941 230.938 66.6571 233.402 69.6955 233.402Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4137 239.689L81.4841 235.758L77.5546 239.689L81.4841 243.621L77.5546 247.552L81.4841 251.484L85.4137 247.552L89.3432 251.484L93.2728 247.552L89.3432 243.621L93.2728 239.689L89.3432 235.758L85.4137 239.689Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.979 203.574H516.657V267.927H580.979V203.574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.745 235.759C541.627 235.759 548.827 228.555 548.827 219.668C548.827 210.782 541.627 203.578 532.745 203.578C523.863 203.578 516.662 210.782 516.662 219.668C516.662 228.555 523.863 235.759 532.745 235.759ZM532.745 230.932C538.962 230.932 544.003 225.889 544.003 219.668C544.003 213.448 538.962 208.405 532.745 208.405C526.527 208.405 521.487 213.448 521.487 219.668C521.487 225.889 526.527 230.932 532.745 230.932Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 203.578H548.827V206.796H580.992V203.578Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 210.016H548.827V213.234H580.992V210.016Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 216.449H548.827V219.667H580.992V216.449Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 222.887H548.827V226.105H580.992V222.887Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 229.324H548.827V232.542H580.992V229.324Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.91 243.803L556.869 235.758L548.827 243.803L556.869 251.848L548.827 259.893L556.869 267.938L564.91 259.893L572.951 267.938L580.992 259.893L572.951 251.848L580.992 243.803L572.951 235.758L564.91 243.803Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 194.887H979.247V276.613H1060.93V194.887Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.665 205.1L989.456 194.887L979.247 205.1L989.456 215.314L979.247 225.527L989.456 235.741L999.665 225.527L1009.87 235.741L1020.08 225.527L1009.87 215.314L1020.08 205.1L1009.87 194.887L999.665 205.1Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 205.1L1030.31 194.887L1020.1 205.1L1030.31 215.314L1020.1 225.527L1030.31 235.741L1040.52 225.527L1050.73 235.741L1060.93 225.527L1050.73 215.314L1060.93 205.1L1050.73 194.887L1040.52 205.1Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.08 235.758H979.247V239.843H1020.08V235.758Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.08 243.93H979.247V248.015H1020.08V243.93Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.08 252.098H979.247V256.183H1020.08V252.098Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.08 260.27H979.247V264.355H1020.08V260.27Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.08 268.441H979.247V272.527H1020.08V268.441Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 235.758H1020.1V239.843H1060.93V235.758Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 243.93H1020.1V248.015H1060.93V243.93Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 252.098H1020.1V256.183H1060.93V252.098Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 260.27H1020.1V264.355H1060.93V260.27Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 268.441H1020.1V272.527H1060.93V268.441Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.83 198.086H1139.54V273.412H1214.83V198.086Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.37 207.51L1148.96 198.094L1139.54 207.51L1148.96 216.926L1139.54 226.343L1148.96 235.759L1158.37 226.343L1167.78 235.759L1177.19 226.343L1167.78 216.926L1177.19 207.51L1167.78 198.094L1158.37 207.51Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.84 198.094H1177.19V201.86H1214.84V198.094Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.84 205.625H1177.19V209.392H1214.84V205.625Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.84 213.16H1177.19V216.927H1214.84V213.16Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.84 220.691H1177.19V224.458H1214.84V220.691Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.84 228.227H1177.19V231.993H1214.84V228.227Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.01 245.174L1186.6 235.758L1177.19 245.174L1186.6 254.59L1177.19 264.007L1186.6 273.423L1196.01 264.007L1205.43 273.423L1214.84 264.007L1205.43 254.59L1214.84 245.174L1205.43 235.758L1196.01 245.174Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.43 203.574H1302.11V267.927H1366.43V203.574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.2 211.623L1310.16 203.578L1302.12 211.623L1310.16 219.668L1302.12 227.713L1310.16 235.759L1318.2 227.713L1326.24 235.759L1334.28 227.713L1326.24 219.668L1334.28 211.623L1326.24 203.578L1318.2 211.623Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.2 267.938C1327.08 267.938 1334.28 260.734 1334.28 251.848C1334.28 242.962 1327.08 235.758 1318.2 235.758C1309.32 235.758 1302.12 242.962 1302.12 251.848C1302.12 260.734 1309.32 267.938 1318.2 267.938ZM1318.2 263.111C1324.42 263.111 1329.46 258.069 1329.46 251.848C1329.46 245.628 1324.42 240.585 1318.2 240.585C1311.98 240.585 1306.94 245.628 1306.94 251.848C1306.94 258.069 1311.98 263.111 1318.2 263.111Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 209.062H1464.69V214.4H1518.04V209.062Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 219.738H1464.69V225.076H1518.04V219.738Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 230.41H1464.69V235.747H1518.04V230.41Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 241.086H1464.69V246.423H1518.04V241.086Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 251.762H1464.69V257.099H1518.04V251.762Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.65 214.547H1627.26V256.953H1669.65V214.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1637.86 235.758C1643.72 235.758 1648.46 231.009 1648.46 225.152C1648.46 219.295 1643.72 214.547 1637.86 214.547C1632.01 214.547 1627.26 219.295 1627.26 225.152C1627.26 231.009 1632.01 235.758 1637.86 235.758ZM1637.86 232.576C1641.96 232.576 1645.28 229.252 1645.28 225.152C1645.28 221.052 1641.96 217.728 1637.86 217.728C1633.77 217.728 1630.44 221.052 1630.44 225.152C1630.44 229.252 1633.77 232.576 1637.86 232.576Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1659.06 235.758C1664.92 235.758 1669.66 231.009 1669.66 225.152C1669.66 219.295 1664.92 214.547 1659.06 214.547C1653.21 214.547 1648.46 219.295 1648.46 225.152C1648.46 231.009 1653.21 235.758 1659.06 235.758ZM1659.06 232.576C1663.16 232.576 1666.48 229.252 1666.48 225.152C1666.48 221.052 1663.16 217.728 1659.06 217.728C1654.97 217.728 1651.64 221.052 1651.64 225.152C1651.64 229.252 1654.97 232.576 1659.06 232.576Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.86 241.06L1632.56 235.758L1627.26 241.06L1632.56 246.363L1627.26 251.666L1632.56 256.968L1637.86 251.666L1643.16 256.968L1648.46 251.666L1643.16 246.363L1648.46 241.06L1643.16 235.758L1637.86 241.06Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.06 241.06L1653.76 235.758L1648.46 241.06L1653.76 246.363L1648.46 251.666L1653.76 256.968L1659.06 251.666L1664.36 256.968L1669.66 251.666L1664.36 246.363L1669.66 241.06L1664.36 235.758L1659.06 241.06Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.313 366.227H207.959V419.606H261.313V366.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.987 392.926C255.355 392.926 261.328 386.95 261.328 379.578C261.328 372.206 255.355 366.23 247.987 366.23C240.619 366.23 234.646 372.206 234.646 379.578C234.646 386.95 240.619 392.926 247.987 392.926ZM247.987 388.922C253.145 388.922 257.326 384.738 257.326 379.578C257.326 374.418 253.145 370.235 247.987 370.235C242.829 370.235 238.648 374.418 238.648 379.578C238.648 384.738 242.829 388.922 247.987 388.922Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.304 419.621C228.672 419.621 234.645 413.645 234.645 406.274C234.645 398.902 228.672 392.926 221.304 392.926C213.936 392.926 207.963 398.902 207.963 406.274C207.963 413.645 213.936 419.621 221.304 419.621ZM221.304 415.617C226.462 415.617 230.643 411.434 230.643 406.274C230.643 401.113 226.462 396.93 221.304 396.93C216.146 396.93 211.965 401.113 211.965 406.274C211.965 411.434 216.146 415.617 221.304 415.617Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.987 419.621C255.355 419.621 261.328 413.645 261.328 406.274C261.328 398.902 255.355 392.926 247.987 392.926C240.619 392.926 234.646 398.902 234.646 406.274C234.646 413.645 240.619 419.621 247.987 419.621ZM247.987 415.617C253.145 415.617 257.326 411.434 257.326 406.274C257.326 401.113 253.145 396.93 247.987 396.93C242.829 396.93 238.648 401.113 238.648 406.274C238.648 411.434 242.829 415.617 247.987 415.617Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.431 344.281H500.206V441.553H597.431V344.281Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.503 356.432L512.35 344.273L500.197 356.432L512.35 368.591L500.197 380.75L512.35 392.909L524.503 380.75L536.656 392.909L548.809 380.75L536.656 368.591L548.809 356.432L536.656 344.273L524.503 356.432Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.07 326.906H954.113V458.926H1086.07V326.906Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.09 326.906H1020.1V333.508H1086.09V326.906Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.09 340.109H1020.1V346.711H1086.09V340.109Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.09 353.312H1020.1V359.914H1086.09V353.312Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.09 366.52H1020.1V373.121H1086.09V366.52Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.09 379.723H1020.1V386.325H1086.09V379.723Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.106 409.431L970.61 392.926L954.113 409.431L970.61 425.935L954.113 442.44L970.61 458.945L987.106 442.44L1003.6 458.945L1020.1 442.44L1003.6 425.935L1020.1 409.431L1003.6 392.926L987.106 409.431Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.75 333.301H1117.6V345.222H1236.75V333.301Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.75 357.145H1117.6V369.066H1236.75V357.145Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.75 380.984H1117.6V392.905H1236.75V380.984Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.75 404.828H1117.6V416.749H1236.75V404.828Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.75 428.668H1117.6V440.589H1236.75V428.668Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.88 344.273H1285.65V354H1382.88V344.273Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.88 363.727H1285.65V373.454H1382.88V363.727Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.88 383.18H1285.65V392.907H1382.88V383.18Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.88 402.637H1285.65V412.364H1382.88V402.637Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.88 422.09H1285.65V431.817H1382.88V422.09Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.37 374.094L1472.55 355.262L1453.73 374.094L1472.55 392.927L1453.73 411.76L1472.55 430.592L1491.37 411.76L1510.2 430.592L1529.02 411.76L1510.2 392.927L1529.02 374.094L1510.2 355.262L1491.37 374.094Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.13 366.227H1621.78V419.606H1675.13V366.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.12 372.904L1628.45 366.23L1621.78 372.904L1628.45 379.578L1621.78 386.252L1628.45 392.926L1635.12 386.252L1641.79 392.926L1648.46 386.252L1641.79 379.578L1648.46 372.904L1641.79 366.23L1635.12 372.904Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.8 372.904L1655.13 366.23L1648.46 372.904L1655.13 379.578L1648.46 386.252L1655.13 392.926L1661.8 386.252L1668.48 392.926L1675.15 386.252L1668.48 379.578L1675.15 372.904L1668.48 366.23L1661.8 372.904Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5455 565.801C86.2213 565.801 93.2545 558.764 93.2545 550.084C93.2545 541.404 86.2213 534.367 77.5455 534.367C68.8696 534.367 61.8364 541.404 61.8364 550.084C61.8364 558.764 68.8696 565.801 77.5455 565.801ZM77.5455 561.086C83.6186 561.086 88.5418 556.16 88.5418 550.084C88.5418 544.008 83.6186 539.082 77.5455 539.082C71.4723 539.082 66.5491 544.008 66.5491 550.084C66.5491 556.16 71.4723 561.086 77.5455 561.086Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.055 520.648H205.218V579.515H264.055V520.648Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.92 557.451L212.566 550.094L205.213 557.451L212.566 564.808L205.213 572.165L212.566 579.523L219.92 572.165L227.274 579.523L234.627 572.165L227.274 564.808L234.627 557.451L227.274 550.094L219.92 557.451Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06 550.094H234.646V553.037H264.06V550.094Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06 555.98H234.646V558.923H264.06V555.98Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06 561.867H234.646V564.81H264.06V561.867Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06 567.75H234.646V570.693H264.06V567.75Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06 573.637H234.646V576.58H264.06V573.637Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.657 493.219H491.98V606.95H605.657V493.219Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.249 550.094C592.946 550.094 605.671 537.363 605.671 521.658C605.671 505.954 592.946 493.223 577.249 493.223C561.552 493.223 548.827 505.954 548.827 521.658C548.827 537.363 561.552 550.094 577.249 550.094ZM577.249 541.563C588.237 541.563 597.145 532.652 597.145 521.658C597.145 510.665 588.237 501.753 577.249 501.753C566.261 501.753 557.354 510.665 557.354 521.658C557.354 532.652 566.261 541.563 577.249 541.563Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.671 550.094H548.827V555.781H605.671V550.094Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.671 561.469H548.827V567.156H605.671V561.469Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.671 572.844H548.827V578.531H605.671V572.844Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.671 584.215H548.827V589.902H605.671V584.215Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.671 595.59H548.827V601.277H605.671V595.59Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.64 471.5H941.545V628.667H1098.64V471.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.1 471.5H941.545V479.359H1020.1V471.5Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.1 487.219H941.545V495.078H1020.1V487.219Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.1 502.938H941.545V510.797H1020.1V502.938Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.1 518.656H941.545V526.515H1020.1V518.656Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.1 534.375H941.545V542.234H1020.1V534.375Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1059.38 550.092C1081.07 550.092 1098.65 532.499 1098.65 510.796C1098.65 489.094 1081.07 471.5 1059.38 471.5C1037.69 471.5 1020.1 489.094 1020.1 510.796C1020.1 532.499 1037.69 550.092 1059.38 550.092ZM1059.38 538.304C1074.56 538.304 1086.87 525.988 1086.87 510.796C1086.87 495.604 1074.56 483.289 1059.38 483.289C1044.19 483.289 1031.88 495.604 1031.88 510.796C1031.88 525.988 1044.19 538.304 1059.38 538.304Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M980.823 628.686C1002.51 628.686 1020.1 611.092 1020.1 589.39C1020.1 567.687 1002.51 550.094 980.823 550.094C959.13 550.094 941.545 567.687 941.545 589.39C941.545 611.092 959.13 628.686 980.823 628.686ZM980.823 616.897C996.007 616.897 1008.32 604.582 1008.32 589.39C1008.32 574.198 996.007 561.883 980.823 561.883C965.638 561.883 953.329 574.198 953.329 589.39C953.329 604.582 965.638 616.897 980.823 616.897Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1059.38 628.686C1081.07 628.686 1098.65 611.092 1098.65 589.39C1098.65 567.687 1081.07 550.094 1059.38 550.094C1037.69 550.094 1020.1 567.687 1020.1 589.39C1020.1 611.092 1037.69 628.686 1059.38 628.686ZM1059.38 616.897C1074.56 616.897 1086.87 604.582 1086.87 589.39C1086.87 574.198 1074.56 561.883 1059.38 561.883C1044.19 561.883 1031.88 574.198 1031.88 589.39C1031.88 604.582 1044.19 616.897 1059.38 616.897Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.73 479.5H1106.63V620.664H1247.73V479.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1141.9 550.075C1161.38 550.075 1177.17 534.276 1177.17 514.787C1177.17 495.299 1161.38 479.5 1141.9 479.5C1122.42 479.5 1106.63 495.299 1106.63 514.787C1106.63 534.276 1122.42 550.075 1141.9 550.075ZM1141.9 539.488C1155.54 539.488 1166.59 528.429 1166.59 514.787C1166.59 501.145 1155.54 490.086 1141.9 490.086C1128.27 490.086 1117.21 501.145 1117.21 514.787C1117.21 528.429 1128.27 539.488 1141.9 539.488Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.46 550.075C1231.94 550.075 1247.73 534.276 1247.73 514.787C1247.73 495.299 1231.94 479.5 1212.46 479.5C1192.98 479.5 1177.19 495.299 1177.19 514.787C1177.19 534.276 1192.98 550.075 1212.46 550.075ZM1212.46 539.488C1226.1 539.488 1237.15 528.429 1237.15 514.787C1237.15 501.145 1226.1 490.086 1212.46 490.086C1198.83 490.086 1187.77 501.145 1187.77 514.787C1187.77 528.429 1198.83 539.488 1212.46 539.488Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1141.9 620.668C1161.38 620.668 1177.17 604.87 1177.17 585.381C1177.17 565.892 1161.38 550.094 1141.9 550.094C1122.42 550.094 1106.63 565.892 1106.63 585.381C1106.63 604.87 1122.42 620.668 1141.9 620.668ZM1141.9 610.082C1155.54 610.082 1166.59 599.023 1166.59 585.381C1166.59 571.739 1155.54 560.68 1141.9 560.68C1128.27 560.68 1117.21 571.739 1117.21 585.381C1117.21 599.023 1128.27 610.082 1141.9 610.082Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.46 567.737L1194.83 550.094L1177.19 567.737L1194.83 585.381L1177.19 603.025L1194.83 620.668L1212.46 603.025L1230.1 620.668L1247.73 603.025L1230.1 585.381L1247.73 567.737L1230.1 550.094L1212.46 567.737Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.11 493.219H1277.43V606.95H1391.11V493.219Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.28 493.223H1277.44V498.91H1334.28V493.223Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.28 504.598H1277.44V510.285H1334.28V504.598Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.28 515.973H1277.44V521.66H1334.28V515.973Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.28 527.344H1277.44V533.031H1334.28V527.344Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.28 538.719H1277.44V544.406H1334.28V538.719Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.7 507.441L1348.49 493.223L1334.28 507.441L1348.49 521.658L1334.28 535.876L1348.49 550.094L1362.7 535.876L1376.91 550.094L1391.13 535.876L1376.91 521.658L1391.13 507.441L1376.91 493.223L1362.7 507.441Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1491.37 593.242C1515.19 593.242 1534.5 573.923 1534.5 550.092C1534.5 526.26 1515.19 506.941 1491.37 506.941C1467.55 506.941 1448.24 526.26 1448.24 550.092C1448.24 573.923 1467.55 593.242 1491.37 593.242ZM1491.37 580.297C1508.05 580.297 1521.56 566.774 1521.56 550.092C1521.56 533.41 1508.05 519.886 1491.37 519.886C1474.7 519.886 1461.18 533.41 1461.18 550.092C1461.18 566.774 1474.7 580.297 1491.37 580.297Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.87 520.648H1619.04V579.515H1677.87V520.648Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.17 528.002L1655.82 520.645L1648.46 528.002L1655.82 535.359L1648.46 542.716L1655.82 550.073L1663.17 542.716L1670.52 550.073L1677.88 542.716L1670.52 535.359L1677.88 528.002L1670.52 520.645L1663.17 528.002Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.17 557.451L1655.82 550.094L1648.46 557.451L1655.82 564.808L1648.46 572.165L1655.82 579.523L1663.17 572.165L1670.52 579.523L1677.88 572.165L1670.52 564.808L1677.88 557.451L1670.52 550.094L1663.17 557.451Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5455 699.393L69.6909 691.535L61.8364 699.393L69.6909 707.252L61.8364 715.11L69.6909 722.968L77.5455 715.11L85.4 722.968L93.2545 715.11L85.4 707.252L93.2545 699.393L85.4 691.535L77.5455 699.393Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.636 733.935C249.368 733.935 261.31 721.987 261.31 707.249C261.31 692.51 249.368 680.562 234.636 680.562C219.905 680.562 207.963 692.51 207.963 707.249C207.963 721.987 219.905 733.935 234.636 733.935ZM234.636 725.929C244.948 725.929 253.308 717.566 253.308 707.249C253.308 696.932 244.948 688.568 234.636 688.568C224.324 688.568 215.965 696.932 215.965 707.249C215.965 717.566 224.324 725.929 234.636 725.929Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.372 669.586H354.083V744.912H429.372V669.586Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.913 679.01L363.501 669.594L354.089 679.01L363.501 688.426L354.089 697.843L363.501 707.259L372.913 697.843L382.325 707.259L391.736 697.843L382.325 688.426L391.736 679.01L382.325 669.594L372.913 679.01Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.736 707.258H354.089V711.024H391.736V707.258Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.736 714.789H354.089V718.556H391.736V714.789Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.736 722.324H354.089V726.091H391.736V722.324Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.736 729.855H354.089V733.622H391.736V729.855Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.736 737.391H354.089V741.157H391.736V737.391Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.56 744.923C420.956 744.923 429.384 736.491 429.384 726.09C429.384 715.689 420.956 707.258 410.56 707.258C400.164 707.258 391.736 715.689 391.736 726.09C391.736 736.491 400.164 744.923 410.56 744.923ZM410.56 739.273C417.837 739.273 423.736 733.371 423.736 726.09C423.736 718.81 417.837 712.908 410.56 712.908C403.283 712.908 397.383 718.81 397.383 726.09C397.383 733.371 403.283 739.273 410.56 739.273Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.9 766.846C738.803 766.846 765.476 740.16 765.476 707.242C765.476 674.323 738.803 647.637 705.9 647.637C672.997 647.637 646.324 674.323 646.324 707.242C646.324 740.16 672.997 766.846 705.9 766.846ZM705.9 748.965C728.932 748.965 747.603 730.285 747.603 707.242C747.603 684.198 728.932 665.518 705.9 665.518C682.868 665.518 664.197 684.198 664.197 707.242C664.197 730.285 682.868 748.965 705.9 748.965Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.09 773.258C1056.53 773.258 1086.07 743.704 1086.07 707.248C1086.07 670.792 1056.53 641.238 1020.09 641.238C983.652 641.238 954.113 670.792 954.113 707.248C954.113 743.704 983.652 773.258 1020.09 773.258ZM1020.09 753.455C1045.6 753.455 1066.28 732.768 1066.28 707.248C1066.28 681.729 1045.6 661.041 1020.09 661.041C994.584 661.041 973.906 681.729 973.906 707.248C973.906 732.768 994.584 753.455 1020.09 753.455Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.76 647.641H1117.6V766.859H1236.76V647.641Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1206.98 707.242C1223.43 707.242 1236.77 693.898 1236.77 677.439C1236.77 660.98 1223.43 647.637 1206.98 647.637C1190.53 647.637 1177.19 660.98 1177.19 677.439C1177.19 693.898 1190.53 707.242 1206.98 707.242ZM1206.98 698.301C1218.5 698.301 1227.83 688.961 1227.83 677.439C1227.83 665.918 1218.5 656.577 1206.98 656.577C1195.46 656.577 1186.13 665.918 1186.13 677.439C1186.13 688.961 1195.46 698.301 1206.98 698.301Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.17 707.258H1117.6V713.218H1177.17V707.258Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.17 719.18H1117.6V725.14H1177.17V719.18Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.17 731.102H1117.6V737.062H1177.17V731.102Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.17 743.02H1117.6V748.98H1177.17V743.02Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.17 754.941H1117.6V760.902H1177.17V754.941Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.89 658.613H1285.66V755.885H1382.89V658.613Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.96 707.241C1323.38 707.241 1334.26 696.353 1334.26 682.923C1334.26 669.493 1323.38 658.605 1309.96 658.605C1296.53 658.605 1285.65 669.493 1285.65 682.923C1285.65 696.353 1296.53 707.241 1309.96 707.241ZM1309.96 699.945C1319.35 699.945 1326.97 692.324 1326.97 682.923C1326.97 673.522 1319.35 665.901 1309.96 665.901C1300.56 665.901 1292.94 673.522 1292.94 682.923C1292.94 692.324 1300.56 699.945 1309.96 699.945Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.96 719.417L1297.8 707.258L1285.65 719.417L1297.8 731.575L1285.65 743.734L1297.8 755.893L1309.96 743.734L1322.11 755.893L1334.26 743.734L1322.11 731.575L1334.26 719.417L1322.11 707.258L1309.96 719.417Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.59 719.417L1346.43 707.258L1334.28 719.417L1346.43 731.575L1334.28 743.734L1346.43 755.893L1358.59 743.734L1370.74 755.893L1382.89 743.734L1370.74 731.575L1382.89 719.417L1370.74 707.258L1358.59 719.417Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.13 680.559H1621.78V733.938H1675.13V680.559Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1635.12 707.258C1642.49 707.258 1648.46 701.282 1648.46 693.91C1648.46 686.538 1642.49 680.562 1635.12 680.562C1627.75 680.562 1621.78 686.538 1621.78 693.91C1621.78 701.282 1627.75 707.258 1635.12 707.258ZM1635.12 703.254C1640.28 703.254 1644.46 699.071 1644.46 693.91C1644.46 688.75 1640.28 684.567 1635.12 684.567C1629.96 684.567 1625.78 688.75 1625.78 693.91C1625.78 699.071 1629.96 703.254 1635.12 703.254Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 680.562H1648.46V683.232H1675.15V680.562Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 685.902H1648.46V688.572H1675.15V685.902Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 691.242H1648.46V693.912H1675.15V691.242Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 696.578H1648.46V699.248H1675.15V696.578Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 701.918H1648.46V704.588H1675.15V701.918Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.12 713.932L1628.45 707.258L1621.78 713.932L1628.45 720.606L1621.78 727.279L1628.45 733.953L1635.12 727.279L1641.79 733.953L1648.46 727.279L1641.79 720.606L1648.46 713.932L1641.79 707.258L1635.12 713.932Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 707.258H1648.46V709.927H1675.15V707.258Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 712.598H1648.46V715.267H1675.15V712.598Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 717.938H1648.46V720.607H1675.15V717.938Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 723.273H1648.46V725.943H1675.15V723.273Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.15 728.613H1648.46V731.283H1675.15V728.613Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2545 848.699H61.8364V880.133H93.2545V848.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4137 864.425C89.7541 864.425 93.2728 860.905 93.2728 856.562C93.2728 852.22 89.7541 848.699 85.4137 848.699C81.0732 848.699 77.5546 852.22 77.5546 856.562C77.5546 860.905 81.0732 864.425 85.4137 864.425ZM85.4137 862.066C88.452 862.066 90.915 859.602 90.915 856.562C90.915 853.522 88.452 851.058 85.4137 851.058C82.3753 851.058 79.9123 853.522 79.9123 856.562C79.9123 859.602 82.3753 862.066 85.4137 862.066Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6955 880.152C74.0359 880.152 77.5546 876.631 77.5546 872.289C77.5546 867.946 74.0359 864.426 69.6955 864.426C65.355 864.426 61.8364 867.946 61.8364 872.289C61.8364 876.631 65.355 880.152 69.6955 880.152ZM69.6955 877.793C72.7338 877.793 75.1968 875.328 75.1968 872.289C75.1968 869.249 72.7338 866.785 69.6955 866.785C66.6571 866.785 64.1941 869.249 64.1941 872.289C64.1941 875.328 66.6571 877.793 69.6955 877.793Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4137 880.152C89.7541 880.152 93.2728 876.631 93.2728 872.289C93.2728 867.946 89.7541 864.426 85.4137 864.426C81.0732 864.426 77.5546 867.946 77.5546 872.289C77.5546 876.631 81.0732 880.152 85.4137 880.152ZM85.4137 877.793C88.452 877.793 90.915 875.328 90.915 872.289C90.915 869.249 88.452 866.785 85.4137 866.785C82.3753 866.785 79.9123 869.249 79.9123 872.289C79.9123 875.328 82.3753 877.793 85.4137 877.793Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.636 885.618C246.34 885.618 255.828 876.126 255.828 864.416C255.828 852.707 246.34 843.215 234.636 843.215C222.933 843.215 213.445 852.707 213.445 864.416C213.445 876.126 222.933 885.618 234.636 885.618ZM234.636 879.257C242.829 879.257 249.47 872.613 249.47 864.416C249.47 856.22 242.829 849.575 234.636 849.575C226.444 849.575 219.802 856.22 219.802 864.416C219.802 872.613 226.444 879.257 234.636 879.257Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.404 837.727H365.05V891.106H418.404V837.727Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.078 844.404L398.407 837.73L391.736 844.404L398.407 851.078L391.736 857.752L398.407 864.426L405.078 857.752L411.748 864.426L418.419 857.752L411.748 851.078L418.419 844.404L411.748 837.73L405.078 844.404Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.395 871.1L371.724 864.426L365.054 871.1L371.724 877.774L365.054 884.447L371.724 891.121L378.395 884.447L385.066 891.121L391.736 884.447L385.066 877.774L391.736 871.1L385.066 864.426L378.395 871.1Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.078 871.1L398.407 864.426L391.736 871.1L398.407 877.774L391.736 884.447L398.407 891.121L405.078 884.447L411.748 891.121L418.419 884.447L411.748 877.774L418.419 871.1L411.748 864.426L405.078 871.1Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.979 832.242H516.657V896.595H580.979V832.242Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.745 840.291L524.704 832.246L516.662 840.291L524.704 848.336L516.662 856.381L524.704 864.427L532.745 856.381L540.786 864.427L548.827 856.381L540.786 848.336L548.827 840.291L540.786 832.246L532.745 840.291Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.91 840.291L556.869 832.246L548.827 840.291L556.869 848.336L548.827 856.381L556.869 864.427L564.91 856.381L572.951 864.427L580.992 856.381L572.951 848.336L580.992 840.291L572.951 832.246L564.91 840.291Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 864.426H548.827V867.644H580.992V864.426Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 870.863H548.827V874.081H580.992V870.863Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 877.297H548.827V880.515H580.992V877.297Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 883.734H548.827V886.952H580.992V883.734Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.992 890.172H548.827V893.39H580.992V890.172Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 823.555H979.247V905.281H1060.93V823.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 823.555H1020.1V827.64H1060.93V823.555Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 831.727H1020.1V835.812H1060.93V831.727Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 839.895H1020.1V843.98H1060.93V839.895Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 848.066H1020.1V852.152H1060.93V848.066Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.93 856.238H1020.1V860.324H1060.93V856.238Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 874.639L1030.31 864.426L1020.1 874.639L1030.31 884.853L1020.1 895.066L1030.31 905.28L1040.52 895.066L1050.73 905.28L1060.93 895.066L1050.73 884.853L1060.93 874.639L1050.73 864.426L1040.52 874.639Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.83 826.754H1139.54V902.08H1214.83V826.754Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.19 826.762H1139.54V830.528H1177.19V826.762Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.19 834.293H1139.54V838.06H1177.19V834.293Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.19 841.828H1139.54V845.595H1177.19V841.828Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.19 849.359H1139.54V853.126H1177.19V849.359Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.19 856.895H1139.54V860.661H1177.19V856.895Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1158.37 902.091C1168.76 902.091 1177.19 893.659 1177.19 883.258C1177.19 872.857 1168.76 864.426 1158.37 864.426C1147.97 864.426 1139.54 872.857 1139.54 883.258C1139.54 893.659 1147.97 902.091 1158.37 902.091ZM1158.37 896.441C1165.64 896.441 1171.54 890.539 1171.54 883.258C1171.54 875.978 1165.64 870.076 1158.37 870.076C1151.09 870.076 1145.19 875.978 1145.19 883.258C1145.19 890.539 1151.09 896.441 1158.37 896.441Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.43 832.242H1302.11V896.595H1366.43V832.242Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.2 872.471L1310.16 864.426L1302.12 872.471L1310.16 880.516L1302.12 888.561L1310.16 896.606L1318.2 888.561L1326.24 896.606L1334.28 888.561L1326.24 880.516L1334.28 872.471L1326.24 864.426L1318.2 872.471Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 837.73H1464.69V843.068H1518.04V837.73Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 848.406H1464.69V853.744H1518.04V848.406Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 859.078H1464.69V864.415H1518.04V859.078Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 869.754H1464.69V875.091H1518.04V869.754Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.04 880.43H1464.69V885.767H1518.04V880.43Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.65 843.215H1627.26V885.621H1669.65V843.215Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.86 848.518L1632.56 843.215L1627.26 848.518L1632.56 853.82L1627.26 859.123L1632.56 864.426L1637.86 859.123L1643.16 864.426L1648.46 859.123L1643.16 853.82L1648.46 848.518L1643.16 843.215L1637.86 848.518Z",
    fill: "#E0991C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1659.06 864.426C1664.92 864.426 1669.66 859.677 1669.66 853.82C1669.66 847.963 1664.92 843.215 1659.06 843.215C1653.21 843.215 1648.46 847.963 1648.46 853.82C1648.46 859.677 1653.21 864.426 1659.06 864.426ZM1659.06 861.244C1663.16 861.244 1666.48 857.92 1666.48 853.82C1666.48 849.72 1663.16 846.396 1659.06 846.396C1654.97 846.396 1651.64 849.72 1651.64 853.82C1651.64 857.92 1654.97 861.244 1659.06 861.244Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1637.86 885.636C1643.72 885.636 1648.46 880.888 1648.46 875.031C1648.46 869.174 1643.72 864.426 1637.86 864.426C1632.01 864.426 1627.26 869.174 1627.26 875.031C1627.26 880.888 1632.01 885.636 1637.86 885.636ZM1637.86 882.455C1641.96 882.455 1645.28 879.131 1645.28 875.031C1645.28 870.931 1641.96 867.607 1637.86 867.607C1633.77 867.607 1630.44 870.931 1630.44 875.031C1630.44 879.131 1633.77 882.455 1637.86 882.455Z",
    fill: "#50CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1659.06 885.636C1664.92 885.636 1669.66 880.888 1669.66 875.031C1669.66 869.174 1664.92 864.426 1659.06 864.426C1653.21 864.426 1648.46 869.174 1648.46 875.031C1648.46 880.888 1653.21 885.636 1659.06 885.636ZM1659.06 882.455C1663.16 882.455 1666.48 879.131 1666.48 875.031C1666.48 870.931 1663.16 867.607 1659.06 867.607C1654.97 867.607 1651.64 870.931 1651.64 875.031C1651.64 879.131 1654.97 882.455 1659.06 882.455Z",
    fill: "#50CAF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_3321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 943,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.944c69def0fdc70778cf8134746a3693.svg";
export { ForwardRef as ReactComponent };